import { loadStripe, type Stripe } from "@stripe/stripe-js";

// Stripe public key - replace with your own
const stripePublicKey =
  import.meta.env.VITE_STRIPE_PUBLIC_KEY || "pk_test_your_stripe_public_key";

// Lazy-load Stripe.js only when actually needed (avoids CORS telemetry errors
// from r.stripe.com/b when Stripe.js is loaded but not used)
let _stripePromise: Promise<Stripe | null> | null = null;
export function getStripePromise(): Promise<Stripe | null> {
  if (!_stripePromise) {
    _stripePromise = loadStripe(stripePublicKey);
  }
  return _stripePromise;
}

/** @deprecated Use getStripePromise() instead – this eagerly loads Stripe.js */
export const stripePromise = null as unknown as Promise<Stripe | null>;

export const TICKET_PRICE = 35.0; // €35.00 (legacy, kept for reference)
export const TICKET_PRICES = {
  vip: 35.0,
  normal: 25.0,
  child: 0,
} as const;
export const SERVICE_FEE = 3.99; // Service fee added to each ticket (except child)
export const CURRENCY = "EUR";
